module.exports = {
    CODE_STATUS_CHECKBOXES: ['INACTIVE', 'ACTIVE', 'EXPIRED'],
    
    CODE_STATUS_VALUES: {
      INACTIVE: ['Inactive', ''],
      ACTIVE: ['Active', 'text-primary'],
      EXPIRED: ['Expired', 'text-danger'],
    },
    
    DURATION_UNITS: {
      DAYS: ['days', 60*60*24],
      WEEKS: ['weeks', 60*60*24*7],
      MONTHS: ['months', 60*60*24*30],
    },
    ACTIVE: 'ACTIVE',
    INACTIVE: 'INACTIVE',
    EXPIRED: 'EXPIRED'
}